enum HelperTextEnum {
	ipd = "IPD je číslo, které jste obdrželi po ověření vaší totožnosti.",
	// email = "Doplňte e-mail uvedený v žádosti o přidělení IPD.",
	PASSWORD_STRENGTH = "Síla hesla",
	STRONG_PASSWORD = "Silné heslo",
	MEDIUM_PASSWORD = "Středně silné heslo",
	WEAK_PASSWORD = "Slabé heslo",
}

export default HelperTextEnum;
